import { render } from "./WaitingPage.vue?vue&type=template&id=21996d48&scoped=true"
import script from "./WaitingPage.vue?vue&type=script&lang=js"
export * from "./WaitingPage.vue?vue&type=script&lang=js"

import "./WaitingPage.vue?vue&type=style&index=0&id=21996d48&lang=scss&scoped=true"

import exportComponent from "C:\\projects\\balkan-app\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21996d48"]])

export default __exports__